import { spawn } from 'redux-saga/effects';

import shipments from 'ducks/shipments';
import auth from 'ducks/auth';
import users from 'ducks/users';
import campaigns from 'ducks/campaigns';
import services from 'ducks/services';

const reducers = {
  auth: auth.reducer,
  shipments: shipments.reducer,
  campaigns: campaigns.reducer,
  users: users.reducer,
  services: services.reducer
};

function* rootSaga() {
  yield spawn(auth.saga);
  yield spawn(shipments.saga);
  yield spawn(campaigns.saga);
  yield spawn(users.saga);
  yield spawn(services.saga);
}

export default {
  rootSaga,
  reducers
};
